export default __webpack_public_path__ + "static/media/whatsapp.5415067c.svg";